import React, { useState } from "react";
import GiftCard from "./GiftCard";

// Print choices for the card: a full Letter page, or four small copies on one
// page with cut lines. Every copy carries the same code. The sheet is always
// in the page (hidden on screen) so the browser prints exactly what is chosen.
export default function GiftCardPrint({ card }) {
  const [size, setSize] = useState("full");
  const [plain, setPlain] = useState(false);

  const cardProps = { ...card, plain, size };

  return (
    <div className="vs-print">
      <div className="vs-print-options no-print">
        <fieldset className="vs-print-sizes">
          <legend className="vsr-label">Print size</legend>
          <label>
            <input type="radio" name="vs-print-size" checked={size === "full"} onChange={() => setSize("full")} /> Full page
            (Letter, landscape)
          </label>
          <label>
            <input type="radio" name="vs-print-size" checked={size === "quarter"} onChange={() => setSize("quarter")} /> Four
            small cards on one page (cut along the lines)
          </label>
        </fieldset>
        <label className="vs-print-plain">
          <input type="checkbox" checked={plain} onChange={(e) => setPlain(e.target.checked)} /> Print with white background
          (uses less ink)
        </label>
        <p className="vsr-hint">
          In the print window choose <b>Letter</b>, landscape, and scale <b>100% / Actual size</b>. Colors can look different on
          every printer, so print one test copy first. {size === "quarter" && "All four cards carry the same Gift Code."}
        </p>
        <button type="button" className="vsr-btn vsr-btn-outline" onClick={() => window.print()}>
          Print / Save as PDF
        </button>
      </div>

      <div className={`gift-print-sheet gift-print-sheet-${size}`} aria-hidden="true">
        {size === "quarter" ? (
          <>
            <div className="vs-cut vs-cut-v" />
            <div className="vs-cut vs-cut-h" />
            {[0, 1, 2, 3].map((i) => (
              <div className="vs-quarter-cell" key={i}>
                <GiftCard {...cardProps} />
              </div>
            ))}
          </>
        ) : (
          <GiftCard {...cardProps} />
        )}
      </div>
    </div>
  );
}
